import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useForm, Controller, FormContext } from 'react-hook-form'
import { isEmpty } from 'lodash'
import { Box, Button, Grid, TextField } from '@material-ui/core'

import {
  Label,
  LoadingFeedback,
  Select as SelectComponent,
  DaiUploadDialog,
  FileUploadInput,
} from 'components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import schema from './schema'
import { routes } from 'Routes'
import useStyles from './styles'
import constants from 'constants/index'
import * as service from 'service'

const PersonalizedServiceForm = ({ ticketType }) => {
  const { DEFAULT_ERRO_MESSAGE, TICKET_SUBJECT, VISIBILITY_TYPE } =
    constants.technicalFaqs

  const snackbar = useSnackbar()
  const classes = useStyles()
  const history = useHistory()

  const [isLoading, setIsLoading] = useState(false)
  const [hasWarned, setHasWarned] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)

  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      title: '',
      content: '',
      subtitle: '',
      visibilityType: 'private_type',
    },
  })

  const { control, handleSubmit, errors, watch } = formMethods

  const attachments = watch('attachments')

  const handleGoBack = () => history.goBack()

  const onSubmit = async (data = {}) => {
    try {
      setIsLoading(true)

      const payload = { ...data, ticketType }

      await service.dponet.juridicTickets.create(payload)

      snackbar.open({
        message: 'Ticket enviado com sucesso!',
        variant: 'success',
      })
      history.push(routes.technicalFaqs.tickets.all)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(
            error?.response?.data?.error,
            false,
          ) || DEFAULT_ERRO_MESSAGE,
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  // Avisa sobre tratamento de dados sensíveis em uploads
  useEffect(() => {
    if (!isEmpty(attachments) && !hasWarned) {
      setOpenDialog(true)
      setHasWarned(true)
    }
  }, [attachments])

  return (
    <Box className={classes.containerBox}>
      <LoadingFeedback open={isLoading} />
      <FormContext {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)} id="knowledge-base-ticket">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Label description="Visibilidade" item xs={12} />
              <Controller
                control={control}
                as={
                  <SelectComponent
                    items={VISIBILITY_TYPE}
                    error={!!errors?.visibilityType}
                    helperText={errors?.visibilityType?.message}
                    className={classes.placeholder}
                  />
                }
                name="visibilityType"
                mode="onBlur"
              />
            </Grid>
            <Grid item xs={12}>
              <Label description="Categoria" item xs={12} />
              <Controller
                control={control}
                as={
                  <SelectComponent
                    items={TICKET_SUBJECT}
                    error={!!errors?.title}
                    helperText={errors?.title?.message}
                    className={classes.placeholder}
                  />
                }
                name="title"
                mode="onBlur"
              />
            </Grid>
            <Grid item xs={12}>
              <Label description="Título" item xs={12} />
              <Controller
                name="subtitle"
                control={control}
                as={
                  <TextField
                    color="primary"
                    variant="outlined"
                    error={!!errors.subtitle}
                    helperText={errors?.subtitle?.message}
                    fullWidth
                  />
                }
                mode="onBlur"
              />
            </Grid>
            <Grid item xs={12}>
              <Label
                description="Descreva sua solicitação (Máximo 3000 caracteres)"
                item
                xs={12}
              />
              <Controller
                control={control}
                as={
                  <TextField
                    type="text"
                    color="primary"
                    variant="outlined"
                    multiline
                    minRows={6}
                    error={!!errors.content}
                    helperText={errors?.content?.message}
                    fullWidth
                  />
                }
                name="content"
                mode="onBlur"
              />
            </Grid>
            <Grid item xs={12}>
              <FileUploadInput
                maxSize={helpers.formatters.file.toBytes(25)}
                controlName="attachments"
                hasDownloadFile
                controllerBar
                multiple
              />
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="end"
                width="100%"
                paddingY={3}
              >
                <Button variant="contained" onClick={handleGoBack}>
                  Voltar
                </Button>
                <Box ml={1}>
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    form="knowledge-base-ticket"
                  >
                    Solicitar Atendimento
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </form>
      </FormContext>
      <DaiUploadDialog open={openDialog} setOpen={setOpenDialog} />
    </Box>
  )
}

export default PersonalizedServiceForm
